import React from 'react'
import Navbar from '../containers/Navbar/Navbar.container'
import ManagementMenu from '../containers/ManagementMenu/ManagementMenu.container'
import routes from '../config/settings/routes'
import ProtectBySession from '../components/Security/ProtectBySession'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import { Map, MapBoundary } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem, Stack } from '@carbon/react'
import { Iframe } from '../containers/Map/Map.styles'
import { CardComponent } from '../components/Layouts/Card.styles'
import Card from '../components/Layouts/Card';
import Typography from '../components/Basics/Typography'
import InformationContainer from '../components/Basics/Information.container'
import KeplerMapContainer from '../containers/Kepler/Kepler.container'

/**
 * The Map's Page.
 */
const Kepler = () => {
  const KeplerBreadCrumbs = () => {
    return (
      <Breadcrumb noTrailingSlash>
        <BreadcrumbItem>
          <a href="/#">Salar</a>
        </BreadcrumbItem>
        <BreadcrumbItem href="#" isCurrentPage>Kepler</BreadcrumbItem>
      </Breadcrumb>
    )
  }

  const title = 'Vista Consolidada de movimientos Históricos'

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <BrandLayout
        navbar={<Navbar managementMenu={<ManagementMenu current={routes.kepler} />} />}
        header={<Heading title={title} icon={<Map size={50} />} breadcrumbs={<KeplerBreadCrumbs />} tooltipContent='Revise y explore la información histórica de movimientos de todos los equipos por fecha.'/>}
      >
        <Stack gap={3}>
        <KeplerMapContainer />

        </Stack>
      </BrandLayout>
    </ProtectBySession>
  )
}

export default Kepler
